import parsePhoneNumberFromString from 'libphonenumber-js';

class PhoneUtils {
  static parsePhoneNumberFromString(value: string) {
    return parsePhoneNumberFromString(value);
  }

  static formatPhoneNumber(value: string) {
    return parsePhoneNumberFromString(value)?.formatInternational() || value;
  }

  static normalizePhoneNumber = (rawPhone: string) => {
    const cleaned = rawPhone.replace(/[^\d+]/g, '');

    if (cleaned.startsWith('+')) {
      return cleaned;
    }

    if (cleaned.startsWith('8')) {
      return `+7${cleaned.slice(1)}`;
    }

    return `+${cleaned}`;
  };
}

export default PhoneUtils;
